import { Quote, Star } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Reveal } from '@/components/Reveal';
import { TextReveal } from '@/components/TextReveal';

// NOTE: Placeholder client stories — replace with real reviews once available.
const TESTIMONIALS = [
  { name: 'Jasmine R.', role: 'Engagement Session \u00b7 Arlington, VA', quote: 'LXRA captured moments we did not even know were happening. Every photo feels like a scene from a film.' },
  { name: 'Marcus T.', role: 'Graduation Shoot \u00b7 Washington, DC', quote: 'Professional, punctual, and incredibly talented. The turnaround was fast and the quality exceeded expectations.' },
  { name: 'Elena V.', role: 'Automotive Shoot \u00b7 Bethesda, MD', quote: 'The cinematic quality of the video reel blew us away. Exactly the vibe we were going for.' },
  { name: 'The Osei Family', role: 'Family Portraits \u00b7 Alexandria, VA', quote: 'Made everyone feel comfortable in front of the camera. The gallery still gives us chills.' },
  { name: 'Priya N.', role: 'Corporate Event \u00b7 Silver Spring, MD', quote: 'Booked LXRA for our launch event and the highlight reel became our best marketing asset.' },
];

const initials = (name) => name.split(' ').map((w) => w[0]).slice(0, 2).join('');

const STAR_SLOTS = ['one', 'two', 'three', 'four', 'five'];

export const TestimonialsCarousel = () => {
  return (
    <section className="bg-[#0A0A0A] border-t border-[hsl(var(--lxra-border))]" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-20 lg:py-28">
        <Reveal>
          <p className="text-xs tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))] mb-2">Client Stories</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-[0.04em] text-[hsl(var(--lxra-fg))]">
            <TextReveal text="WHAT THEY'RE SAYING" />
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Carousel opts={{ align: 'start', loop: true }} className="w-full" data-testid="testimonials-carousel">
            <CarouselContent>
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={t.name} className="md:basis-1/2 lg:basis-1/3" data-testid={`testimonial-card-${i}`}>
                  <div className="h-full rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] p-6 sm:p-7 flex flex-col gap-4">
                    <Quote className="h-6 w-6 text-[hsl(var(--lxra-gold))]" />
                    <p className="text-sm sm:text-base text-[hsl(var(--lxra-fg))] leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
                    <div className="flex items-center gap-1">
                      {STAR_SLOTS.map((s) => (
                        <Star key={s} className="h-3.5 w-3.5 fill-[hsl(var(--lxra-gold))] text-[hsl(var(--lxra-gold))]" />
                      ))}
                    </div>
                    <div className="flex items-center gap-3 pt-3 border-t border-[hsl(var(--lxra-border))]">
                      <Avatar className="h-9 w-9 border border-[hsl(var(--lxra-gold))]/30">
                        <AvatarFallback className="bg-[#141416] text-[hsl(var(--lxra-gold))] text-xs font-semibold">
                          {initials(t.name)}
                        </AvatarFallback>
                      </Avatar>
                      <div>
                        <p className="text-sm font-semibold text-[hsl(var(--lxra-fg))]">{t.name}</p>
                        <p className="text-xs text-[hsl(var(--lxra-muted))]">{t.role}</p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden sm:flex -left-4 lg:-left-6 border-[hsl(var(--lxra-border))] bg-[#141416] text-[hsl(var(--lxra-fg))] hover:bg-[#1c1c1f] hover:text-[hsl(var(--lxra-gold))]" data-testid="testimonials-prev-button" />
            <CarouselNext className="hidden sm:flex -right-4 lg:-right-6 border-[hsl(var(--lxra-border))] bg-[#141416] text-[hsl(var(--lxra-fg))] hover:bg-[#1c1c1f] hover:text-[hsl(var(--lxra-gold))]" data-testid="testimonials-next-button" />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
};
